<div class="layout-container" [ngClass]="containerClass">
  <p-toast />
  <!-- <p-messages
      class="custom-message-style"
    /> -->

  @if (!authService.checkIfUserHasAVerifiedAuthItem() && activeApp === SIBASI_APPS.EBMSUITE) {
    <div class="text-center bg-orange-400 py-2 text-white">
      <span class=""> Verify your email to avoid losing your account. You won't be able to log in once you log out: </span>
      <span class="link clickable" (click)="resendVerificationEmail()"> Resend verification Email </span>
    </div>
  }

  <div class="layout-content-wrapper">
    <app-topbar></app-topbar>
    <app-breadcrumb class="content-breadcrumb"></app-breadcrumb>
    <div class="layout-content">
      <router-outlet></router-outlet>
    </div>
    <div class="layout-mask"></div>
  </div>
  <app-profilemenu (phoneNumberAvailable)="onPhoneNumberAvailable($event)"></app-profilemenu>
  <app-config></app-config>
</div>
